export const DPAScriptId = "dpa-script";
